module.exports = __webpack_public_path__ + "static/media/Probability.6faba3b3.svg";